import React from "react";
import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div data-testid="payment-cancel-page" className="flex min-h-screen items-center justify-center bg-obsidian px-5 pt-24">
      <div className="w-full max-w-lg border border-white/10 bg-surface p-10 text-center">
        <XCircle size={52} strokeWidth={2.5} className="mx-auto text-white/40" />
        <h1 className="mt-6 font-heading text-4xl uppercase text-white">Payment Cancelled</h1>
        <p className="mt-3 font-body text-sm text-white/70">No worries — you weren't charged. You can pick a program and try again whenever you're ready.</p>
        <div className="mt-8 flex flex-wrap justify-center gap-3">
          <Link to="/training" data-testid="cancel-training-btn" className="bg-neon-green px-8 py-4 font-heading text-sm uppercase tracking-widest text-black">View Programs</Link>
          <Link to="/" className="border border-white/20 px-8 py-4 font-heading text-sm uppercase tracking-widest text-white hover:border-neon-green hover:text-neon-green">Home</Link>
        </div>
      </div>
    </div>
  );
}
